import { Component, inject, input } from '@angular/core';
import { RegionItemDto, TeamItemDto, TeamService } from '@artemis-software/wr-api';
import { NbToastrService } from '@nebular/theme';
import { watch } from '@/utils/signals/watch';

@Component({
  standalone: false,
  selector: 'wr-region-dashboard-teamcards',
  templateUrl: './region-dashboard-teamcards.component.html',
  styleUrls: ['./region-dashboard-teamcards.component.scss'],
})
export class RegionDashboardTeamcardsComponent {

  readonly region = input<RegionItemDto | undefined>();
  readonly teamService = inject(TeamService);
  readonly toastr = inject(NbToastrService);

  teams: TeamItemDto[] = [];

  constructor() {
    watch(this.region, (region) => {
      this.teams = [];
      if (region?.id) {
        this.teamService.getTeamsByRegionId(region.id).subscribe({
          next: (teams) => (this.teams = teams),
          error: () =>
            this.toastr.danger(
              'Teams für die Region konnten nicht geladen werden.',
              'Fehler'
            ),
        });
      }
    });
  }

  goToTeam(team: TeamItemDto): void {
    if (team.id) {
      window.location.href = `/team/${team.id}`;
    } else {
      this.toastr.warning('Team-ID ist nicht verfügbar.', 'Warnung');
    }
  }
}
